// TODO: replace by an ES6 import using
// export default
// instead of module.exports

var encode = require('base64util').encode;

var Util = {
	/** @function bindMethods
	 * Makes sure `this` is statically bound to all own function properties of an object you pass to this function.
	 * @param obj {Object}  The object to statically bind `this` in.
	 * @param [methods] {Array.<string>}  Optional list of method names to statically bind.
	 * @returns {Object} The modified object.
	 */
	bindMethods: function bindMethods(obj, methods) {
		if (!methods) {
			methods = [];
			for (var key in obj) {
				if (!obj.hasOwnProperty(key) || !(obj[key] instanceof Function)) {
					continue;
				}
				methods.push(key);
			}
		}
		methods.forEach(function (key) {
			obj[key] = obj[key].bind(obj);
		});
		return obj;
	},

	/** @function exportMethods
	 * Returns a fresh object containing all or a selected set of own
	 * function properties of an object you pass to it.
	 * Optionally prefixes method names on the returned object.
	 * @param obj {Object}  The object you want to extract methods from.
	 * @param [opt] {Object}  Optional list of method names to extract.
	 * @param [opt.prefix] {string}  Optional list of method names to extract.
	 * @param [opt.methods] {Array.<string>}  Optional list of method names to extract.
	 * @returns {Object} A fresh object containing all own function properties from @param obj.
	 */
	exportMethods: function exportMethods(obj, opt) {
		opt = opt || {};
		opt.prefix = opt.prefix ? opt.prefix + '_' : '';

		if (!opt.methods) {
			opt.methods = [];
			for (var key in obj) {
				if (!obj.hasOwnProperty(key) || !('function' === typeof obj[key])) {
					continue;
				}
				opt.methods.push(key);
			}
		}
		var tempObj = {};
		opt.methods.forEach(function (key) {
			tempObj[opt.prefix + key] = obj[key];
		});
		return tempObj;
	},

	/** @function guid
	 * Creates a format conforming guid (globally unique identifier) string.
	 * @returns {string} Returns a format compliant guid string, e.g. 936DA01F-9ABD-4D9D-80C7-02AF85C822A8.
	 */
	guid: () => {
		function s4() {
			return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
		}
		return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
	},

	/** @function isGuid
	 * Checks if a string is a valid guid (globally unique identifier).
	 * @param guidToCheck {string} The string to test for guid compliance.
	 * @returns {boolean} Returns true if guidToCheck conforms to guid format, otherwise returns false.
	 */
	isGuid: (guidToCheck) => {
		var pattern = /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i;
		return pattern.test(guidToCheck);
	},
	//atob: base64js.decode,
	btoa: encode,
};

module.exports = Util;



// WEBPACK FOOTER //
// ./src/assets/js/util/util.js